import React from 'react'

export const RoamDots = (props) => (
    <svg width="27px" height="28px" viewBox="0 0 27 28" version="1.1" {...props}>
      <g fillRule="nonzero" strokeWidth="1">
        <path d="M24.1 6.3a2.7 2.7 0 1 1 0-5.4 2.7 2.7 0 0 1 0 5.4zm0 10.7a2.7 2.7 0 1 1 0-5.4 2.7 2.7 0 0 1 0 5.4zM13.4 6.3a2.7 2.7 0 1 1 0-5.4 2.7 2.7 0 0 1 0 5.4zm0 10.7a2.7 2.7 0 1 1 0-5.4 2.7 2.7 0 0 1 0 5.4zm0 10.7a2.7 2.7 0 1 1 0-5.4 2.7 2.7 0 0 1 0 5.4zM2.7 17a2.7 2.7 0 1 1 0-5.4 2.7 2.7 0 0 1 0 5.4zm0 10.7a2.7 2.7 0 1 1 0-5.4 2.7 2.7 0 0 1 0 5.4z"/>
      </g>
    </svg>
)

export const RoamLogo = (props) => (
    <svg xmlns="http://www.w3.org/2000/svg" width="87" height="16" version="1.1" {...props}>
      <path fill="#FFF" fillRule="nonzero" stroke="none" strokeWidth="1" d="M58.8.5V2c-.5-1-2-2-4-2a8 8 0 0 0 0 16c2 0 3.5-1 4-2v1.5h4V.5h-4zM37.5 0a8 8 0 1 1 0 16 8 8 0 0 1 0-16zm0 4a4 4 0 0 0-4 4 4 4 0 0 0 4 4 4 4 0 0 0 4-4 4 4 0 0 0-4-4zm17.3 8a4 4 0 0 1-4-4 4 4 0 0 1 4-4 4 4 0 0 1 4 4 4 4 0 0 1-4 4zM82 0c2 0 5 1.8 5 6.5v9h-4v-9C83 5.1 81.9 4 80.5 4A2.5 2.5 0 0 0 78 6.5v9h-4v-9C74 5.1 72.9 4 71.5 4A2.5 2.5 0 0 0 69 6.5v9h-4V.5h4V2c.5-1 2-2 4-2s3.4 1 4.2 2.3C78 1 79.4 0 82 0zM23.2.5V2c.6-1 2-2 4-2a8 8 0 0 1 2.5.4l-1.1 3.8A4 4 0 0 0 23.2 8v7.5h-4V.5h4zm-9.7 3a1.5 1.5 0 1 1 0-3 1.5 1.5 0 0 1 0 3zm0 6a1.5 1.5 0 1 1 0-3 1.5 1.5 0 0 1 0 3zm-6-6a1.5 1.5 0 1 1 0-3 1.5 1.5 0 0 1 0 3zm0 6a1.5 1.5 0 1 1 0-3 1.5 1.5 0 0 1 0 3zm0 6a1.5 1.5 0 1 1 0-3 1.5 1.5 0 0 1 0 3zm-6-6a1.5 1.5 0 1 1 0-3 1.5 1.5 0 0 1 0 3zm0 6a1.5 1.5 0 1 1 0-3 1.5 1.5 0 0 1 0 3z"/>
    </svg>
)

export const PersonFrame = (props) => (
    <svg width="14px" height="16px" viewBox="0 0 14 16" version="1.1" {...props}>
        <g fill="none" fillRule="evenodd" stroke="none" strokeLinecap="round" strokeLinejoin="round" strokeWidth="1">
          <g stroke="#181424"  strokeWidth="1.5">
            <path d="M13 15H1c0-4.4 2.7-8 6-8s6 3.6 6 8z"/>
            <path d="M10 4a3 3 0 1 1-6 0 3 3 0 0 1 6 0z"/>
          </g>
        </g>
    </svg>
)

export const TimeClock = (props) => (
    <svg width="16px" height="16px" viewBox="0 0 16 16" version="1.1" {...props}>
        <g fill="none" fillRule="evenodd" stroke="none" strokeLinecap="round" strokeLinejoin="round" strokeWidth="1">
          <g stroke="#181424" strokeWidth="1.5">
            <path d="M15 8A7 7 0 1 1 1 8a7 7 0 0 1 14 0z"/>
            <path d="M8 5v3.2l3 1.8"/>
          </g>
        </g>
    </svg>
)

export const DifficultyEasy = (props) => (
    <svg width="16px" height="16px" viewBox="0 0 8 16" version="1.1" {...props}>
        <g fill="none" fillRule="evenodd" stroke="none" strokeLinecap="round" strokeLinejoin="round" strokeWidth="1">
          <g stroke="#181424" strokeWidth="1.5">
            <path d="M1 3.9L4 1l2.9 2.9m0 8.2l-3 2.9L1 12.1m3.5-4c0 .3-.2.4-.4.4a.3.3 0 0 1-.3-.3c0-.2.1-.4.3-.4.2 0 .4.2.4.4"/>
          </g>
        </g>
    </svg>
)

export const DifficultyMedium = (props) => (
    <svg width="17px" height="16px" viewBox="0 0 17 16" version="1.1" {...props}>
        <g fill="none" fillRule="evenodd" stroke="none" strokeLinecap="round" strokeLinejoin="round" strokeWidth="1">
          <g stroke="#181424" strokeWidth="1.5">
            <path d="M13 5.6L15.2 8 13 10.4m-2.3 2.2L8.2 15l-2.5-2.4m0-9.2L8.2 1l2.4 2.4m-4.9 0L8.2 1l2.4 2.4m-7.2 7L1 8l2.4-2.4M8.6 8c0 .2-.2.4-.4.4a.4.4 0 0 1-.5-.4c0-.2.2-.4.5-.4.2 0 .4.2.4.4"/>
          </g>
        </g>
    </svg>
)

export const DifficultyHard = (props) => (
    <svg width="15px" height="15px" viewBox="0 0 15 15" {...props}>
        <g fill="none" fillRule="evenodd" stroke="none" strokeLinecap="round" strokeLinejoin="round" strokeWidth="1">
          <g stroke="#181424" strokeWidth="1.5">
            <path d="M4.9 13.7l2.4-2.3 2.4 2.3M1 5.2l2.4 2.4L1 9.9m12.6 0l-2.4-2.3 2.4-2.4M9.7 1.4L7.3 3.8 5 1.4M7.3 8a.4.4 0 0 1-.4-.4c0-.3.2-.5.4-.5.3 0 .5.2.5.5 0 .2-.2.4-.5.4z"/>
          </g>
        </g>
    </svg>
)

export const DownArrow = (props) => (
    <svg width="20" height="19" {...props}>
        <g fill="none" fillRule="evenodd" stroke="none" strokeLinecap="round" strokeLinejoin="round" strokeWidth="1">
            <g stroke="#FFF" strokeWidth="1.6">
                <path d="M10 1.6V18m8.3-8.6L10 18.1 1.7 9.5"/>
            </g>
        </g>
    </svg>
)

export const ArrowUpRight = (props) => (
    <svg width="14" height="14" version="1.1" {...props}>
        <path fill="none" fillRule="evenodd" stroke="#181424" strokeLinecap="round" strokeLinejoin="round" strokeWidth="1.6" d="M1 13L12.7 1.3M.8 1.5l12-.2-.3 11.9"/>
    </svg>
)



// WEBPACK FOOTER //
// ./src/assets/svg.js